import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ReadReceipt = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 4.5C4 3.67157 4.67157 3 5.5 3H18.5C19.3284 3 20 3.67157 20 4.5V12.6923C20 12.9684 19.7761 13.1923 19.5 13.1923C19.2239 13.1923 19 12.9684 19 12.6923V4.5C19 4.22386 18.7761 4 18.5 4H5.5C5.22386 4 5 4.22386 5 4.5V19.5C5 19.7761 5.22386 20 5.5 20H9.27273C9.54887 20 9.77273 20.2239 9.77273 20.5C9.77273 20.7761 9.54887 21 9.27273 21H5.5C4.67157 21 4 20.3284 4 19.5V4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM7.5 10.5C7.22386 10.5 7 10.7239 7 11C7 11.2761 7.22386 11.5 7.5 11.5H13.5C13.7761 11.5 14 11.2761 14 11C14 10.7239 13.7761 10.5 13.5 10.5H7.5Z"
          fill={color}
        />
        <path
          d="M10.5 17.5L14.7857 22.5L22.5 13.5"
          fill="transparent"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ReadReceipt
